import * as yup from 'yup';
export const directorySchema = yup.object().shape({
  directoryEnabled: yup.boolean(),
  isTest: yup.boolean(),
});
